import script from "./LogoutPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoutPage.vue?vue&type=script&setup=true&lang=js"

import "./LogoutPage.vue?vue&type=style&index=0&id=0f8a6cac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f8a6cac"]])

export default __exports__